// Admin CRM test-id registry
export const ADMIN = {
  loginPage: "admin-login-page",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  dashboard: "admin-dashboard",
  logoutButton: "admin-logout-button",
  statCard: (k) => `admin-stat-${k}`,

  leadsTable: "admin-leads-table",
  leadRow: (id) => `admin-lead-row-${id}`,
  leadOpen: (id) => `admin-lead-open-${id}`,

  filterStatus: "admin-filter-status",
  searchInput: "admin-search-input",
  sortToggle: "admin-sort-toggle",

  drawer: "admin-lead-drawer",
  drawerClose: "admin-lead-drawer-close",
  drawerStatus: "admin-lead-drawer-status",
  drawerNotes: "admin-lead-drawer-notes",
  drawerSave: "admin-lead-drawer-save",
  drawerCallLink: "admin-lead-drawer-call",
  drawerEmailLink: "admin-lead-drawer-email",
};
